import React from "react";

import DashboardIcon from "../../../assets/images/dashboard.png";
import GroupsIcon from "../../../assets/images/groups.png";
import ReportsIcon from "../../../assets/images/reports.png";
// import ActivityIcon from "../../../assets/images/activity.png";
import { Email } from "@material-ui/icons";

export const menus = [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: DashboardIcon,
    path: "/group",
  },
  {
    id: "participants",
    title: "Users",
    icon: GroupsIcon,
    path: "/group/participants",
  },
  {
    id: "invitation",
    title: "Invite Users",
    muiIcon: () => <Email style={{ margin: 0 }} />,
    path: "/group/invitation",
  },
  {
    id: "reports",
    title: "Reports",
    icon: ReportsIcon,
    path: "/group/reports",
  },
  /* {
    id: "activity",
    title: "Activity",
    icon: ActivityIcon,
    path: "/group/activity"
  } */
];
